import AuthenticationRepository from './v1/AuthenticationRepository';
import UsersRepository from './v1/UsersRepository';
import CountriesRepository from './v1/CountriesRepository';
import MedicalInstitutionsRepository from './v1/MedicalInstitutionsRepository';
import HospitalsRepository from './v1/HospitalsRepository';
import RolesRepository from './v1/RolesRepository';
import MedicalTeamRepository from './v1/MedicalTeamRepository';
import TrustedHubRepository from './v1/TrustedHubRepository';
import MedicalDeviceRepository from './v1/MedicalDeviceRepository';
import PatientMetaDataRepository from './v1/PatientMetaDataRepository';
import NoSessionHubsRepository from './v1/NoSessionHubsRepository';
import VerifiersRepository from './v1/VerifiersRepository';
import DoctorMetaDataRepository from './v1/DoctorMetaDataRepository';
import NurseMetaDataRepository from './v1/NurseMetaDataRepository';
import PublicLinksRepository from './v1/PublicLinksRepository';
import SocketRepository from './v1/SocketRepository';
import NotificationsRepository from './v1/NotificationsRepository';
import TreatMentPlanRepository from './v1/TreatMentPlanRepository';
import GoogleAPIReposotiry from './v1/GoogleAPIRepository';
import AppointmentsRepository from './v1/AppointmentsRepository';
import AppointmentRequestsRepository from './v1/AppointmentRequestsRepository';
import BillingsRepository from './v1/BillingsRepository';
import MentalHealthRepository from './v1/MentalHealthRepository';
import FilterbarRepository from '@/data/store/modules/filterbar';
import ReportsRepository from './v1/ReportsRepository';
import PatientDiagnosisRepository from './v1/PatientDiagnosisRepository';
import SaRepository from './v1/SaRepository';
import TimeTrackingRepository from './v1/TimeTrackingRepository';
import InvoicesRepository from './v1/InvoicesRepository';
import BillingAuthorizationRepository from './v1/BillingAuthorizationRepository';
import UserBillingsAuthorizationRepository from './v1/UserBillingsAuthorizationRepository';
import MedicalNoteCategoryRepository from './v1/MedicalNoteCategoryRepository';
import AdminRepository from './v1/AdminRepository';
import LogsRepository from './v1/LogsRepository';
import LicensesRepository from './v1/LicensesRepository';
import PrescriptionRepository from './v1/PrescriptionRepository';
import CCMRecordsRepository from './v1/CCMRecordsRepository';
import CCMTimeLogsRepository from './v1/CCMTimeLogsRepository';
import CCMDiagnosesRepository from './v1/CCMDiagnosesRepository';
import CCMConditionsRepository from './v1/CCMConditionsRepository';
import CCMCarePlansRepository from './v1/CCMCarePlansRepository';
import CCMMedicationEventRepository from './v1/CCMMedicationEventRepository';
import CCMVitalEntryRepository from './v1/CCMVitalEntryRepository';
import CCMMedicalNoteRepository from './v1/CCMMedicalNoteRepository';
import CCMObservationRepository from './v1/CCMObservationRepository';
import CCMAllergyRepository from './v1/CCMAllergyRepository';
import CCMBillingRepository from './v1/CCMBillingRepository';
import CCMAttachmentRepository from './v1/CCMAttachmentRepository';
import CCMConsentFormRepository from './v1/CCMConsentFormRepository';
import CCMVaccineRepository from './v1/CCMVaccineRepository';
import CCMImagingRepository from './v1/CCMImagingRepository';
import CCMLabsRepository from './v1/CCMLabsRepository';
import TabletsRepository from './v1/TabletsRepository';
import TerraRepository from './v1/TerraRepository';
import ReleaseNotesRepository from './v1/ReleaseNotesRepository';
import ScheduleRepository from './v1/ScheduleRepository';
import PCCRepository from './v1/PCCRepository';
import InventoryItemCatalogsRepository from './v1/InventoryItemCatalogsRepository';
import InventoryConsumableCatalogsRepository from './v1/InventoryConsumableCatalogsRepository';
import InventoryItemRepository from './v1/InventoryItemRepository';
import InventoryConsumableRepository from './v1/InventoryConsumableRepository';
import LogLevelsRepository from './v1/LogLevelsRepository';
import AuditRepository from './v1/AuditRepository';

const repositories = {
	authentication: AuthenticationRepository,
	billingAuthorization: BillingAuthorizationRepository,
	userBillingsAuthorization: UserBillingsAuthorizationRepository,
	logsRepository: LogsRepository,
	filterbar: FilterbarRepository,
	users: UsersRepository,
	medicalnotecategory: MedicalNoteCategoryRepository,
	countries: CountriesRepository,
	invoices: InvoicesRepository,
	mentalhealth: MentalHealthRepository,
	medicalInstitutions: MedicalInstitutionsRepository,
	hospitals: HospitalsRepository,
	roles: RolesRepository,
	medicalteam: MedicalTeamRepository,
	trustedhub: TrustedHubRepository,
	medicaldevice: MedicalDeviceRepository,
	patientmetadata: PatientMetaDataRepository,
	nosessionhubs: NoSessionHubsRepository,
	verifiers: VerifiersRepository,
	doctormetadata: DoctorMetaDataRepository,
	nursemetadata: NurseMetaDataRepository,
	publiclinks: PublicLinksRepository,
	websocket: SocketRepository,
	notifications: NotificationsRepository,
	reportsRepo: ReportsRepository,
	treatmentplan: TreatMentPlanRepository,
	googleAPI: GoogleAPIReposotiry,
	appointments: AppointmentsRepository,
	appointmentrequests: AppointmentRequestsRepository,
	billings: BillingsRepository,
	patientdiagnosis: PatientDiagnosisRepository,
	sarepository: SaRepository,
	timetracking: TimeTrackingRepository,
	admin: AdminRepository,
	licenses: LicensesRepository,
	prescriptions: PrescriptionRepository,
	ccmRecords: CCMRecordsRepository,
	ccmTimeLogs: CCMTimeLogsRepository,
	ccmDiagnoses: CCMDiagnosesRepository,
	ccmConditions: CCMConditionsRepository,
	ccmCarePlans: CCMCarePlansRepository,
	ccmMedicationEvents: CCMMedicationEventRepository,
	ccmVitalEntry: CCMVitalEntryRepository,
	ccmMedicalNote: CCMMedicalNoteRepository,
	ccmObservation: CCMObservationRepository,
	ccmAllergy: CCMAllergyRepository,
	ccmBilling: CCMBillingRepository,
	ccmAttachments: CCMAttachmentRepository,
	ccmConsentForms: CCMConsentFormRepository,
	ccmVaccines: CCMVaccineRepository,
	ccmImaging: CCMImagingRepository,
	ccmLabs: CCMLabsRepository,
	tablets: TabletsRepository,
	terra: TerraRepository,
	releaseNotes: ReleaseNotesRepository,
	schedules: ScheduleRepository,
	pcc: PCCRepository,
	inventoryItemCatalogs: InventoryItemCatalogsRepository,
	inventoryConsumableCatalogs: InventoryConsumableCatalogsRepository,
	inventoryItems: InventoryItemRepository,
	inventoryConsumables: InventoryConsumableRepository,
	logLevels: LogLevelsRepository,
	audits: AuditRepository,
};
export default {
	get: (name) => {
		if (repositories[name]) {
			return repositories[name];
		} else {
			throw new Error('Invalid Repository Type');
		}
	},
};
